import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Tooltip from "@mui/material/Tooltip";

import ButtonPrimary from "../../../components/button/ButtonPrimary";
import Draggable from "react-draggable";
import InputText from "../../../components/input/InputText";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getConfig, searchAPI } from "../../../apis";
import { toast } from "react-toastify";
import DateComponent from "../../../components/DateComponent";
import { getFormattedDate } from "../../../functions/time";
import { logEvent } from "../../../functions/amplitude";
import { useIsMobile } from "../../../functions/isMobile";
import { axiosInstance } from "../../../functions/axios";

const EditBookmark = (props) => {
  const isMobile = useIsMobile();
  const {
    setCustomBookmarkPopup,
    getBookmarks,
    title,
    setDarkBackground,
    customBookmarkPopup,
    bookmark,
    setBookmark,
  } = props;

  console.log(bookmark);

  const { user } = useSelector((state) => state.auth);

  const params = useParams();

  const [position, setPosition] = useState({
    marginTop: 0,
    marginLeft: 0,
  });
  const [calendarPopup, setCalendarPopup] = useState(false);

  const format_response = () => {
    let commonResponse = {
      callingUserId: user.userId,
      userId: user.userId,
      collectionId: params.id,
      ...bookmark,
      ...(bookmark.sourcePublishedDateTime && {
        sourcePublishedDateTime: new Date(bookmark.sourcePublishedDateTime),
      }),

      title: bookmark.title.length === 0 ? bookmark.sourceURL : bookmark.title,
    };
    return commonResponse;
  };

  const setDate = (date) => {
    console.log(date, bookmark);
    setBookmark((prev) => ({
      ...prev,
      sourcePublishedDateTime: date,
    }));
  };

  const handleSave = async () => {
    if (!bookmark.sourceURL) {
      toast.error("URL is required.");
      return;
    }
    try {
      const json_res = format_response();
      const res = await axiosInstance.post(
        searchAPI.AddUpdateCollectionsSource,
        json_res,
        getConfig()
      );

      const amplitude_bookmark = {
        publication: json_res.sourceName,
        bookmarkurl: json_res.sourceURL,
      };

      logEvent("click_bookmark_save", amplitude_bookmark);

      toast.success("Saved to collection");
      getBookmarks(params.id);
      setBookmark({
        sourceName: "",
        title: "",
        sourceURL: "",
        sourcePublishedDateTime: "",
      });
      setCustomBookmarkPopup(false);
    } catch {
      toast.error("Something went wrong, please try later.");
    } finally {
      setDarkBackground(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSave();
    }
  };

  const handleDrag = (e, ui) => {
    const { x, y } = ui;
    setPosition((prevPosition) => ({
      ...prevPosition,
      marginTop: y,
      marginLeft: x,
    }));
  };

  return (
    customBookmarkPopup && (
      <div className="new-custom-bookmark-container">
        <Draggable
          position={{
            x: position.marginLeft,
            y: position.marginTop,
          }}
          onDrag={handleDrag}
          cancel={isMobile ? ".new-custom-bookmark-popup" : null}
        >
          <div
            onKeyDown={(e) => handleKeyDown(e)}
            className="new-custom-bookmark-popup"
          >
            <div className="popup-card">
              <CloseIcon
                className="cross"
                onClick={() => {
                  setDarkBackground(false);
                  setCustomBookmarkPopup(false);
                }}
              />
              <p className="popup-title"></p>
              <div className="col">
                <p className="mb-2">URL:</p>
                <InputText
                  onChange={(e) =>
                    setBookmark((prev) => ({
                      ...prev,
                      sourceURL: e.target.value,
                    }))
                  }
                  value={bookmark.sourceURL}
                  placeholder="Required"
                />
              </div>
              <div className="col">
                <p className="mb-2">Source:</p>
                <InputText
                  onChange={(e) =>
                    setBookmark((prev) => ({
                      ...prev,
                      sourceName: e.target.value,
                    }))
                  }
                  value={bookmark.sourceName}
                  placeholder="Optional"
                />
              </div>
              <div className="col">
                <p className="mb-2">Title:</p>
                <InputText
                  onChange={(e) =>
                    setBookmark((prev) => ({ ...prev, title: e.target.value }))
                  }
                  value={bookmark.title}
                  placeholder="Optional"
                />
              </div>{" "}
              <div className="col">
                <p className="mb-2">Published Date:</p>
                <div
                  className="input-container"
                  style={{ position: "relative" }}
                >
                  <InputText
                    onChange={(e) =>
                      setBookmark((prev) => ({
                        ...prev,
                        sourcePublishedDateTime: e.target.value,
                      }))
                    }
                    value={
                      getFormattedDate(bookmark.sourcePublishedDateTime) ===
                      "NA"
                        ? ""
                        : getFormattedDate(bookmark.sourcePublishedDateTime)
                    }
                    placeholder="Optional"
                  />
                  <Tooltip title="View calendar">
                    <CalendarMonthIcon
                      style={{ cursor: "pointer" }}
                      className="mb-3"
                      onClick={() => setCalendarPopup((prev) => !prev)}
                    />
                  </Tooltip>
                </div>
              </div>
              <div className="save-actions">
                <div />
                <div className="flex">
                  <ButtonPrimary
                    text="Cancel"
                    onClick={() => {
                      setDarkBackground(false);
                      setCustomBookmarkPopup(false);
                    }}
                    className="mr-2 grey"
                    outline
                  />
                  <ButtonPrimary text="Save" onClick={handleSave} />
                </div>
              </div>
            </div>
          </div>
        </Draggable>
        {calendarPopup && (
          <DateComponent
            setCalendarPopup={setCalendarPopup}
            reqDate={new Date(bookmark.sourcePublishedDateTime)}
            setDate={setDate}
            requiredDates={0}
          />
        )}
      </div>
    )
  );
};

export default EditBookmark;
